import { useState } from "react";
import GlobalStyles from "./styles/GlobalStyles";
import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import { useAuth } from "./hooks";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CompaniesPage from "./pages/CompaniesPage";
import HackersPage from "./pages/HackersPage";
import ProgrammesPage from "./pages/ProgrammesPage";
import ReportsPage from "./pages/ReportsPage";
import EncryptionPage from "./pages/EncryptionPage";
import RankingPage from "./pages/RankingPage";
import AdminManagementPage from "./pages/AdminManagementPage";

const PAGE_META = {
  dashboard:  { title: "Dashboard",              sub: "Vue d'ensemble de la plateforme" },
  companies:  { title: "Entreprises",             sub: "Gestion des comptes entreprises" },
  hackers:    { title: "Gestion des Hackers",     sub: "Profils, KYC et performances" },
  programmes: { title: "Programmes Bug Bounty",   sub: "Administration des programmes actifs" },
  reports:    { title: "Rapports de Sécurité",    sub: "Vulnérabilités soumises et traitées" },
  encryption: { title: "Chiffrement E2E",         sub: "Clés RSA et accès d'urgence" },
  ranking:    { title: "Classement",              sub: "Hall of Fame des meilleurs hackers" },
  "admin-mgmt": { title: "Administration",        sub: "Gestion des comptes administrateurs" },
};

const App = () => {
  const { token, user, login, logout, isAuthenticated } = useAuth();
  const [page, setPage] = useState("dashboard");

  if (!isAuthenticated) {
    return (
      <>
        <GlobalStyles />
        <LoginPage onLogin={login} />
      </>
    );
  }

  const meta = PAGE_META[page] || { title: "200Bounty Admin" };
  const props = { token, user };

  const renderPage = () => {
    switch (page) {
      case "dashboard":  return <DashboardPage {...props} />;
      case "companies":  return <CompaniesPage {...props} />;
      case "hackers":    return <HackersPage {...props} />;
      case "programmes": return <ProgrammesPage {...props} />;
      case "reports":    return <ReportsPage {...props} />;
      case "encryption": return <EncryptionPage {...props} />;
      case "ranking":    return <RankingPage {...props} />;
      case "admin-mgmt": return <AdminManagementPage {...props} />;
      default:           return <DashboardPage {...props} />;
    }
  };

  return (
    <>
      <GlobalStyles />
      <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
        <Sidebar
          user={user}
          activePage={page}
          setPage={setPage}
          onLogout={logout}
        />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: "#080b14" }}>
          <TopBar title={meta.title} subtitle={meta.sub} />
          <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            {renderPage()}
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
